import axios from 'axios';
import router from '../router';

export default {
    state: { 
        user: null,
        isLoggedIn: false, 
    },
    mutations: { 
        set_user (state, data) {
          state.user = data
          state.isLoggedIn = true
        }, 
        reset_user (state) {
          state.user = null
          state.isLoggedIn = false
        }
    },
    getters:{ 
        isLoggedIn (state){
          // console.log("ini state: ");
          // console.log(state.user);
          return state.isLoggedIn
          // return new Promise((resolve, reject) => { 
          //   axios.post('login', data)
          //    .then(response => {
          //      localStorage.setItem('idUser', response.data.data.id_user) 
          //      localStorage.setItem('emailUser', response.data.data.email) 
          //      localStorage.setItem('hakAkses', response.data.data.ha) 
          //      localStorage.setItem('kodeRef', response.data.data.kode_referral) 
          //      const token = response.data.token  
          //      localStorage.setItem('token', token) 
          //      setHeaderToken(token) 
          //      dispatch('get_user')
          //      resolve(response)
          //    })
          //    .catch(err => {
          //      commit('reset_user')  
          //      localStorage.removeItem('token')
          //      reject(err)
          //   })
          // })
        },
        user (state) {
          return state.user
        }
    },
    actions: { 
        // login(credentials) {
        //     return axios
        //     .post(url + 'login/', credentials)
        //     .then(response => response.data);
        // },
        // signUp(credentials) {
        //     return axios
        //     .post(url + 'register', credentials)
        //     .then(response => response.data);
        // },
        register({ dispatch, commit }, data) {
          return new Promise((resolve, reject) => { 
           axios.post('register', data)
            .then(resp => { 
             resolve(resp);
            })
            .catch(err => {
             commit('reset_user')   
             reject(err)
            })
          })
        },
        login({ dispatch, commit }, data) {
          return new Promise((resolve, reject) => { 
            // console.log(data);
            axios.post('login', data)
             .then(response => {
              if(response.data.status == 'success'){
                localStorage.setItem('idUser', response.data.data.id_user) 
                localStorage.setItem('emailUser', response.data.data.email) 
                localStorage.setItem('hakAkses', response.data.data.ha) 
                localStorage.setItem('kodeRef', response.data.data.kode_referral) 
                localStorage.setItem('kdtoken', response.data.data.token) 
                const token = response.data.token  
                localStorage.setItem('token', token) 
                setHeaderToken(token) 
                dispatch('get_user')
                resolve(response)
              } else {                
              //  commit('reset_user')  
              //  localStorage.removeItem('token')
               reject(response.data.message)
              }
             })
             .catch(err => {
               commit('reset_user')  
               localStorage.removeItem('token')
               reject(err)
            })
          })
        },
        logout({ commit }) {
          return new Promise((resolve) => {
           commit('reset_user')
           localStorage.removeItem('token')           
           localStorage.removeItem('idUser') 
           localStorage.removeItem('emailUser') 
           localStorage.removeItem('hakAkses') 
           localStorage.removeItem('kodeRef') 
           removeHeaderToken()
           resolve()
          })
         },
        async get_user({commit}){ 
          if(!localStorage.getItem('token')){
            return
          }
          try{ 
            let response = await axios.get('api/user/'+localStorage.getItem('idUser'))
              commit('set_user', response.data.data)
          } catch (error){
              commit('reset_user') 
              removeHeaderToken()
              localStorage.removeItem('token')
              return error
          } 
        },
        checktoken({ dispatch, commit }, data) {
          return new Promise((resolve, reject) => { 
            if(!localStorage.getItem('token')){
              // return
                router.push("/login").catch(()=>{});
                return;
            }
            // console.log("masuk check token");
            setHeaderToken(localStorage.getItem('token')); 
            axios.get('api/checktoken')
             .then(response => {               
               const check = response.data.message;
              //  console.log("hasil checktoken: ");  
              //  console.log(data);  
              if(check != "1"){
                commit('reset_user');
                localStorage.removeItem('token');
                router.push("/login").catch(()=>{});
                // next({name:'Login'});
              }
              //  localStorage.setItem('token', token) 
              //  setHeaderToken(token) 
              //  dispatch('get_user')
              //  resolve(response)
             })
             .catch(err => {
               commit('reset_user');
               localStorage.removeItem('token');
                // next({name:'Login'});
                $router.push("/login").catch(()=>{});
               reject(err);
            })
          })
        },
        
    }, 
    // login(credentials) {
    //     return axios
    //     .post(url + 'login/', credentials)
    //     .then(response => response.data);
    // },
    // signUp(credentials) {
    //     return axios
    //     .post(url + 'register', credentials)
    //     .then(response => response.data);
    // },
    // getSecretContent() {
    //     return axios.get(url + 'secret-route/').then(response => response.data);
    // }
};

export function setHeaderToken (token) { 
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
};

export function removeHeaderToken () {
    delete axios.defaults.headers.common['Authorization']
};


// WEBPACK FOOTER //
// ./src/store/auth.js